<template>
  <b-container id="container" fluid>
    <div class="row">
      <div class="d-none d-md-flex col-md-4 col-lg-6 b-img"></div>
      <div
        class="form col-12 col-md-8 col-lg-6 bg-white
        d-flex flex-column align-items-center justify-content-center"
      >
        <img src="favicon.ico" height="100px" width="100px" class="mb-4">
        <form class="text-center" v-if="!sent">
          <h4 class="mb-4">PASSWORD FORGOTTEN</h4>
          <p>Enter your Account-Email to receive instructions to reset your password.</p>
          <input
            autofocus
            class="form-control rounded-0"
            :class="{ 'border-danger': emailMissing }"
            placeholder="Email"
            type="email"
            v-model="email"
          >
          <div class="d-flex mb-4">
            <b-button
              block
              class="bg-green border-0 py-2 rounded-0"
              @click="reset"
            >RESET PASSWORD</b-button>
          </div>
          <div>Back to <router-link :to="{ name: 'Login' }" class="green">Login</router-link></div>
        </form>
        <div v-else>
          <h4 class="mb-4 text-centergit ">EMAIL SENT</h4>
          <p>An Email has been sent to you with instructions to reset your password.</p>
          <b-button block class="bg-green border-0 rounded-0"
                    :to="{ name: 'Login' }">Back to Login</b-button>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      error: false,
      email: '',
      emailMissing: false,
      sent: false,
    };
  },
  methods: {
    reset() {
      // TODO RESET REQUEST
      this.error = false;
      this.emailMissing = false;
      this.sent = false;
      if (!this.email) this.emailMissing = true;
      if (!this.email) {
        this.error = true;
      }
      this.sent = true;
    },
  },
};
</script>

<style scoped>
  .bg-green {
    background-color: rgb(0, 173, 94);
    color: white;
  }
  .green {
    color: rgb(0, 173, 94);
  }
  .form {
    height: 100vh;
  }
  .b-img {
    background: url("https://i.imgur.com/xX8r70i.jpg") no-repeat center;
    height: 100vh;
  }
</style>
